export default "__VITE_ASSET__C$LnDl7M__"